import type {RouteLocationNormalized} from 'vue-router';
import {defineNuxtRouteMiddleware} from '#imports';
import {useNavbarMode} from '../composables/useNavbarMode';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
    useNavbarMode().applyNavbarMode(to.path, to.meta.navbar);
});
